export const acceptData = {
  image: "image/png, image/gif, image/jpeg",
  file: ".jpg,.jpeg,.png,.pdf,.doc,.docx",
};
